import styled from 'styled-components';

export const List = styled.ul`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};

  margin: 0;
  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};

  list-style: none;
`;

export const ListItem = styled.li``;
